<template>
  <div v-if="selectedDesign">
    <RevIllustration
      :alt="
        i18n(translations.selectedDesign, { designType: selectedDesign.type })
      "
      class="shadow-short rounded-md overflow-hidden"
      :height="498"
      :src="selectedDesign.assetUrl"
      :width="498"
    />

    <RevCardCarousel
      :center="false"
      class="mt-48 [&_li]:w-[112px]"
      :next-alternative-text="i18n(translations.alternativeNext)"
      :prev-alternative-text="i18n(translations.alternativePrevious)"
      :title="i18n(translations.title)"
    >
      <div v-for="designPicker in designPickers" :key="designPicker.id">
        <RevIllustration
          :alt="
            i18n(translations.chooseDesign, { designType: designPicker.type })
          "
          class="rounded-md overflow-hidden"
          :class="
            designPicker.id === selectedDesign.id
              ? 'border-[1.5px] border-static-default-hi'
              : 'border-[0.5px] border-static-default-low'
          "
          :height="70"
          :src="designPicker.thumbnailUrl"
          :width="112"
          @click="handleDesignPickerClick(designPicker)"
        />
      </div>
    </RevCardCarousel>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './DesignPickers.translations'

const i18n = useI18n()
type DesignPicker =
  ApiSpecs['/api/gift-cards/v1/product-page/giftcard']['GET']['response']['designPickers'][number]

const props = defineProps<{
  designPickers: DesignPicker[]
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue'])

const selectedDesign = ref<DesignPicker | undefined>(
  props.designPickers.find(
    (designPicker) => designPicker.id === props.modelValue,
  ),
)

function handleDesignPickerClick(designPicker: DesignPicker) {
  selectedDesign.value = designPicker
  emit('update:modelValue', designPicker.id)
}
</script>
